export default "__VITE_PUBLIC_ASSET__fcacf165__"